<div class="pb-10 overflow-y-auto bg-grey-lightest">
	<app-teranet-title-search
		[isOverview]="false"
		class="bg-white"
		(searchCompletedEvent)="onSearchCompleted($event)"
	></app-teranet-title-search>
</div>

<ui-content-footer
	*ngIf="showFooter"
	[primaryAction]="{ text: 'Continue', action: next }"
	[testHook]="testHooks.ContentFooter"
></ui-content-footer>
